module.exports = __webpack_public_path__ + "media/images/icons/icon-ruler-58406e8525d4eb6002018bcae3de2312.svg";